/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS python filter api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GeoJson } from './GeoJson';
import {
    GeoJsonFromJSON,
    GeoJsonFromJSONTyped,
    GeoJsonToJSON,
} from './GeoJson';
import type { GroundingParameters } from './GroundingParameters';
import {
    GroundingParametersFromJSON,
    GroundingParametersFromJSONTyped,
    GroundingParametersToJSON,
} from './GroundingParameters';

/**
 * 
 * @export
 * @interface BaseConfiguration
 */
export interface BaseConfiguration {
    /**
     * Unique identifier for the record
     * @type {number}
     * @memberof BaseConfiguration
     */
    id?: number | null;
    /**
     * Universal unique identifier for the record
     * @type {string}
     * @memberof BaseConfiguration
     */
    uuid?: string | null;
    /**
     * Created at this point in time
     * @type {Date}
     * @memberof BaseConfiguration
     */
    createdAt?: Date | null;
    /**
     * Created by this user
     * @type {string}
     * @memberof BaseConfiguration
     */
    createdBy?: string | null;
    /**
     * Modified at this point in time
     * @type {Date}
     * @memberof BaseConfiguration
     */
    modifiedAt?: Date | null;
    /**
     * Modified by this user
     * @type {string}
     * @memberof BaseConfiguration
     */
    modifiedBy?: string | null;
    /**
     * Name of the configuration
     * @type {string}
     * @memberof BaseConfiguration
     */
    name?: string;
    /**
     * Is the configuration enabled
     * @type {boolean}
     * @memberof BaseConfiguration
     */
    enabled?: boolean | null;
    /**
     * 
     * @type {GroundingParameters}
     * @memberof BaseConfiguration
     */
    parameters?: GroundingParameters;
    /**
     * Severity of the configuration
     * @type {string}
     * @memberof BaseConfiguration
     */
    severity?: string | null;
    /**
     * Id of shape to check for groundings within.
     * @type {string}
     * @memberof BaseConfiguration
     */
    shape?: string | null;
    /**
     * 
     * @type {GeoJson}
     * @memberof BaseConfiguration
     */
    geometry?: GeoJson;
    /**
     * List of phone numbers to notify in case of a grounding event
     * @type {Array<string>}
     * @memberof BaseConfiguration
     */
    phoneNumbers?: Array<string>;
    /**
     * List of email addresses to notify in case of a grounding event
     * @type {Array<string>}
     * @memberof BaseConfiguration
     */
    emailAddresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseConfiguration
     */
    acl?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseConfiguration
     */
    aclPut?: Array<string>;
}

/**
 * Check if a given object implements the BaseConfiguration interface.
 */
export function instanceOfBaseConfiguration(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BaseConfigurationFromJSON(json: any): BaseConfiguration {
    return BaseConfigurationFromJSONTyped(json, false);
}

export function BaseConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'createdAt': !exists(json, 'created_at') ? undefined : (json['created_at'] === null ? null : new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'modifiedAt': !exists(json, 'modified_at') ? undefined : (json['modified_at'] === null ? null : new Date(json['modified_at'])),
        'modifiedBy': !exists(json, 'modified_by') ? undefined : json['modified_by'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'parameters': !exists(json, 'parameters') ? undefined : GroundingParametersFromJSON(json['parameters']),
        'severity': !exists(json, 'severity') ? undefined : json['severity'],
        'shape': !exists(json, 'shape') ? undefined : json['shape'],
        'geometry': !exists(json, 'geometry') ? undefined : GeoJsonFromJSON(json['geometry']),
        'phoneNumbers': !exists(json, 'phone_numbers') ? undefined : json['phone_numbers'],
        'emailAddresses': !exists(json, 'email_addresses') ? undefined : json['email_addresses'],
        'acl': !exists(json, 'acl') ? undefined : json['acl'],
        'aclPut': !exists(json, 'acl_put') ? undefined : json['acl_put'],
    };
}

export function BaseConfigurationToJSON(value?: BaseConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'uuid': value.uuid,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt === null ? null : value.createdAt.toISOString()),
        'created_by': value.createdBy,
        'modified_at': value.modifiedAt === undefined ? undefined : (value.modifiedAt === null ? null : value.modifiedAt.toISOString()),
        'modified_by': value.modifiedBy,
        'name': value.name,
        'enabled': value.enabled,
        'parameters': GroundingParametersToJSON(value.parameters),
        'severity': value.severity,
        'shape': value.shape,
        'geometry': GeoJsonToJSON(value.geometry),
        'phone_numbers': value.phoneNumbers,
        'email_addresses': value.emailAddresses,
        'acl': value.acl,
        'acl_put': value.aclPut,
    };
}

